import { render, staticRenderFns } from "./AntreanKlinik.vue?vue&type=template&id=4cb2cdc2&"
import script from "./AntreanKlinik.vue?vue&type=script&lang=js&"
export * from "./AntreanKlinik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports